import React from "react";
import { DEFAULT_PAGE, DEFAULT_FETCHED_OPTIONS, DEFAULT_DEBOUNCE_TIMEOUT } from "consts";
import { getPublicProjectsAndTasks } from "api";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const ProjectTaskUnionAutoSuggest = (props) => (
    <AutoSuggest
        label="Project/Task"
        fetchOptions={(q) => props.onDataFetch(q)}
        renderOption={(entry) => ({
            label: entry.TaskId
                ? `${entry.TaskKey} - ${entry.TaskTitle}`
                : `${entry.ProjectKey} - ${entry.ProjectTitle}`,
            value: entry
        })}
        optionIdentifier={(entry) => entry.TaskId || entry.ProjectId}
        debounceTimeout={DEFAULT_DEBOUNCE_TIMEOUT}
        {...props}
    />
);

ProjectTaskUnionAutoSuggest.defaultProps = {
    onDataFetch: (q) =>
        getPublicProjectsAndTasks(q, DEFAULT_PAGE, DEFAULT_FETCHED_OPTIONS, null, null, true)
            .then(value => value.content)
}

export default ProjectTaskUnionAutoSuggest;
